import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import './Header.css';
import logo from '../assets/logo.png';

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [q, setQ] = useState('');
  function onKey(e) {
    if (e.key === 'Enter') navigate(`/search?q=${encodeURIComponent(q)}`);
  }
  const pathname = location.pathname;
  const isHome = pathname === '/';
  const hideNavSearch = pathname.startsWith('/downloads') || pathname.startsWith('/viewer');
  const showTopRightLogo = pathname !== '/';
  return (
    <header className={`site-header ${!isHome ? 'is-inner' : ''}`}>
      <div className="site-header-inner container">
        <Link to="/" className="brand" aria-label="Shramajeevi Images home">
          Shramajeevi Images
        </Link>
        {!isHome && (
          <Link to="/" className="header-center" aria-label="Go to home">
            <img className="header-logo" src={logo} alt="Shramajeevi logo" />
          </Link>
        )}
        <nav className="nav">
          {!hideNavSearch && (
            <div className="search">
              <div className="search-box">
                <input placeholder="Search images..." value={q} onChange={e=>setQ(e.target.value)} onKeyDown={onKey} />
              </div>
            </div>
          )}
          {showTopRightLogo && (
            <img className="nav-logo" src={logo} alt="Shramajeevi logo" />
          )}
        </nav>
      </div>
    </header>
  );
}

